const isAuthenticated = async () => {
    const user = await localStorage.getItem('@lighthouse_jjeletrica:user')
    if (user.token)
        return true
    else
        return false
}

export default isAuthenticated